import DocumentPolicy from './policies/DocumentPolicy';
import SitePolicy from './policies/SitePolicy';
import ProjectPolicy from './policies/ProjectPolicy';

export default class Gate
{
    constructor(user) {
        console.log('Gate initialized with user:', user);
        this.user = user || {};

        // Initialize policy instances
        this.policies = {
            document: new DocumentPolicy(),
            site: new SitePolicy(),
            project: new ProjectPolicy()
        };
        
        console.log('Initialized policies:', this.policies);
    }

    before() {
        return this.user.role.name === 'admin';
    }

    can(action, type, model = null) {
        try {
            console.log(`Checking permission: ${action} on ${type}`, { model });
            
            // Check if user is properly initialized
            if (!this.user || !this.user.role) {
                console.warn('User or user role not properly initialized');
                return false;
            }

            // Admin check
            if (this.before()) {
                console.log('Access granted: User is admin');
                return true;
            }

            // Check if policy exists
            if (!this.policies[type]) {
                console.warn(`Policy '${type}' not found`);
                return false;
            }

            // Check if action exists in policy
            const policy = this.policies[type];
            const actionFn = policy[action];
            
            if (typeof actionFn !== 'function') {
                console.warn(`Action '${action}' not found in policy '${type}'`, { 
                    availableActions: Object.getOwnPropertyNames(Object.getPrototypeOf(policy)).filter(
                        prop => typeof policy[prop] === 'function' && prop !== 'constructor'
                    )
                });
                return false;
            }

            // Execute the policy
            const result = actionFn.call(policy, this.user, model);
            console.log(`Policy check result for ${action} on ${type}:`, result);
            return result;
            
        } catch (error) {
            console.error('Error in Gate.can():', error);
            return false;
        }
    }

    cannot(action, type, model = null) {
        return ! this.can(action, type, model);
    }

    isAdmin() {
        return this.before();
    }
    isClientAdmin() {
        return this.user.role?.name === 'client_admin';
    }
    isClientUser() {
        return this.user.role?.name === 'client_user';
    }
    isBroker() {
        return this.user.role?.name === 'broker';
    }
    isToolboxUser() {
        // Check by role_id (6 is toolbox_user) or by role.name if role is loaded
        if (this.user && this.user.role_id === 6) {
            return true;
        }
        return this.user && this.user.role && this.user.role.name === 'toolbox_user';
    }
}